import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { BreadcrumbJsonLd, CarouselJsonLd } from 'next-seo';
import Layout from '~/layouts/ThemeLayout';
import SEOTags from '~/components/SEOTags';
import { PATH, SectionsKey } from '~/constants/enum';
import { GET_CATEGORIES_V2 } from '~/data/categories';
import { UseCategoryPageResponse } from '~/data/categories/interface';
import useRenderComponent from '~/hooks/useRenderComponent';
import { CategoriesProps } from '~/sections/Categories/Categories';
import { initializeSSRApollo } from '~/utils/apollo-client';
import { getUrlByTheme } from '~/utils/theme';

const CategoryPage = ({ categories }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    const { render } = useRenderComponent<CategoriesProps>({
        fileName: 'categories',
        sectionData: {
            [SectionsKey.Category]: {
                data: categories
            }
        }
    });
    const itemListElements = [
        {
            position: 1,
            name: 'Home',
            item: process.env.NEXT_PUBLIC_URL + ''
        },
        {
            position: 2,
            name: 'Categories',
            item: getUrlByTheme(PATH.Categories)
        }
    ];
    return (
        <Layout>
            {<BreadcrumbJsonLd itemListElements={itemListElements} />}
            {!!categories?.items?.length && (
                <CarouselJsonLd
                    ofType="default"
                    data={categories?.items?.map((i: any) => {
                        return {
                            name: i?.name,
                            image: i?.image,
                            url: getUrlByTheme(PATH.CategoryDetail.replace('[slug]', i?.url_key))
                        };
                    })}
                />
            )}
            <SEOTags title="Categories" />
            {render()}
        </Layout>
    );
};

export default CategoryPage;

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const apolloClient = initializeSSRApollo({
        httpLinkProps: { useGETForQueries: true }
    });
    const { data } = await apolloClient.query({
        query: GET_CATEGORIES_V2
    });
    const { categories } = data || {};

    return {
        props: {
            categories
        }
    };
};
